"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormattedSelectOption = getFormattedSelectOption;
exports.getInitialValues = getInitialValues;
exports.parseFormValuesToAPI = parseFormValuesToAPI;
exports.friendlyFieldValue = friendlyFieldValue;
exports.filterValuesVisible = filterValuesVisible;
exports.prefillReadOnlyFields = prefillReadOnlyFields;
exports.parseSubmitValues = parseSubmitValues;
exports.composeFieldYesNo = composeFieldYesNo;
exports.composeFieldAck = composeFieldAck;
exports.composeFieldDate = composeFieldDate;
exports.composeFieldMoney = composeFieldMoney;
exports.composeFieldCountries = composeFieldCountries;
exports.composeFieldCountriesMulti = composeFieldCountriesMulti;
exports.composeFieldNumber = composeFieldNumber;
exports.composeFieldText = composeFieldText;
exports.composeFieldTextarea = composeFieldTextarea;
exports.composeFieldExtra = composeFieldExtra;
exports.composeFieldSelect = composeFieldSelect;
exports.moneyFieldBase = exports.getDisplayFields = exports.supportedTypes = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _get = _interopRequireDefault(require("lodash/get"));

var _constants = require("../../../domains/employee/constants");

var _helpers = require("../../../domains/employment/employer/contractDetails/helpers");

var _currency = require("../../../helpers/currency");

var _general = require("../../../helpers/general");

var _validationSchema = require("../../../helpers/validationSchema");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var supportedTypes = {
  TEXT: 'text',
  TEXTAREA: 'textarea',
  NUMBER: 'number',
  SELECT: 'select',
  MASK: 'mask',
  COUNTRIES: 'countries',
  FILE: 'file',
  RADIO: 'radio',
  RADIO_CARD: 'radio-card',
  GROUP_ARRAY: 'group-array',
  EXTRA: 'extra',
  TEL: 'tel',
  EMAIL: 'email',
  DOWNLOAD_FILE_UPLOAD: 'download-file-upload',
  MONEY: 'money',
  // Don't forget to convert to/from cents if you need to!
  HIDDEN: 'hidden',
  DATE: 'date',
  ACK_CHECK: 'ack-check'
};
exports.supportedTypes = supportedTypes;

function getDefaultValueForType(type) {
  switch (type) {
    case supportedTypes.FILE:
      return undefined;
    // Allows fallback values in function declarations to be used

    default:
      return '';
  }
}

function getFormattedSelectOption(fieldValue, options) {
  var option = options.find(function (each) {
    return each.value === fieldValue;
  });
  return option && option.label;
}
/**
 * Support pre-defined values for an input
 * @param {*} defaultValues
 * @param {*} field
 */


function getInitialDefaultValue(defaultValues, field) {
  // lodash get is needed because some values could be nested obejct, like billing address
  var defaultFieldValue = (0, _get["default"])(defaultValues, field.name);

  if (field.parseValueFromAPI) {
    var value = field.parseValueFromAPI(defaultFieldValue);
    if (value) return value;
  }

  var generatedValue = typeof field.value === 'function' ? field.value(defaultFieldValue, defaultValues) : field.value;
  return generatedValue || defaultFieldValue || getDefaultValueForType(field.type);
} // Given a fields config array and default values (ex from API),
// build initialValues to be consumed by Formik


function getInitialValues(fields, defaultValues) {
  var initialValues = {}; // loop over fields array
  // if prop does not exit in the initialValues object,
  // pluck off the name and value props and add it to the initialValues object;

  fields.forEach(function (field) {
    if (field.type === supportedTypes.GROUP_ARRAY) {
      var fieldName = field.name;
      initialValues[fieldName] = defaultValues[fieldName];
    } else if (!initialValues[field.name] && field.type !== supportedTypes.EXTRA) {
      initialValues[field.name] = getInitialDefaultValue(defaultValues, field);
    }
  });
  return initialValues;
} // used to display fieldValues on the UI


var getDisplayFields = function getDisplayFields(fields, data) {
  var formValues = getInitialValues(fields, data);
  return fields.filter(function (fieldItem) {
    var isVisible = fieldItem.visibilityCondition ? fieldItem.visibilityCondition(formValues) : true;
    return fieldItem.type !== supportedTypes.EXTRA && isVisible;
  }).map(function (field) {
    return _objectSpread({
      title: field.label,
      value: field.formatDisplay ? // needs isNotInCents because the convertion already happens above on getInitialValues
      field.formatDisplay(formValues[field.name], {
        isNotInCents: true
      }) : formValues[field.name]
    }, field.maskSecret ? {
      maskSecret: field.maskSecret
    } : {});
  });
};
/**
 * Convert form fields values to have the correct format for the API.
 * @param {Object} formValues - List with form values { name: value }.
 * @param {Array} fields - Respective form fields configuration.
 * @returns {Object} values - The values for the API.
 * @example (if MONEY field) 500.50 -> 50050
 */


exports.getDisplayFields = getDisplayFields;

function parseFormValuesToAPI() {
  var formValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fields = arguments.length > 1 ? arguments[1] : undefined;
  var filteredFields = fields.filter(function (field) {
    return field.name in formValues;
  });
  return filteredFields.reduce(function (acc, field) {
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, field.name, field.parseValueToAPI ? field.parseValueToAPI(formValues[field.name]) : formValues[field.name]));
  }, formValues);
}
/**
 * Common attributes for supportedTypes.MONEY
 * TODO: Deprecate this in favor of composeFieldMoney
 */


var moneyFieldBase = {
  type: supportedTypes.MONEY,
  value: function value(_value) {
    return (_value === null || _value === void 0 ? void 0 : _value.toString()) || '';
  },
  parseValueFromAPI: _currency.convertFromCents,
  parseValueToAPI: _currency.convertToCents,
  formatDisplay: function formatDisplay(value) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // Do not turn into arrow function to preserve "this"
    var money = opts.isNotInCents ? (0, _currency.convertToCents)(value) : value;
    return (0, _currency.friendlyMoney)(money, {
      code: this.currency
    });
  }
};
/**
 * Returns the API value in a more friendly way based on its field configs
 * @param {String} value - The field value to be converted
 * @param {Object} field - The respective field settings
 * @param {Function} field.formatDisplay - Optional. Return a friendly version of the value.
 */

exports.moneyFieldBase = moneyFieldBase;

function friendlyFieldValue(value, field) {
  if (!(field !== null && field !== void 0 && field.formatDisplay)) return (0, _general.friendlyLabel)(value);
  return (0, _general.friendlyLabel)(field.formatDisplay(value));
}
/**
 * Given a list of form values, returns the ones that were really asked
 * In other words, it excludes the values which the respective field
 * was hidden, based on its visibilityCondition config.
 * @param {Object} values - List with form values { name: value }.
 * @param {Array} fields - Respective form fields configuration.
 */


function filterValuesVisible(values, fields) {
  var valuesAsked = {};
  fields.forEach(function (field) {
    var fieldAsked = field.visibilityCondition ? field.visibilityCondition(values) : true;
    if (!fieldAsked) return;
    valuesAsked[field.name] = values[field.name];
  });
  return valuesAsked;
}
/**
 * Given a list of form values, modify the ones that are readOnly,
 * based on their field config, by adding its defaultValue.
 * This is needed to support readOnly fields that are also conditional
 * based on the "pivotName" workaround.
 * @param {Object} values - List with form values { name: value }.
 * @param {Array} fields - Respective form fields configuration.
 */


function prefillReadOnlyFields(values, fields) {
  var newValues = {};
  fields.forEach(function (field) {
    var fieldName = field.name;
    if (!(fieldName in values)) return;

    if (field.readOnly && field.defaultValue) {
      newValues[fieldName] = field.defaultValue;
    } else {
      newValues[fieldName] = values[fieldName];
    }
  });
  return newValues;
}
/**
 * Ensure the form fields from Formik are saved properly to the API
 * @param {Object} formValues - List with form values { name: value }.
 * @param {Array} fields - Respective form fields configuration.
 * @returns {Object} - The correct values to the API.
 */


function parseSubmitValues(formValues, fields) {
  var convertedFormValues = parseFormValuesToAPI(formValues, fields);
  var formValuesAsked = filterValuesVisible(convertedFormValues, fields);
  var valuesWithReadOnly = prefillReadOnlyFields(formValuesAsked, fields);
  return valuesWithReadOnly;
}
/**
 * Return base attributes needed for a radio field with yes / not options.
 * @param {Object} attrs
 * @return {Object}
 */


function composeFieldYesNo(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? true : _ref$required,
      attrs = (0, _objectWithoutProperties2["default"])(_ref, ["name", "label", "required"]);
  var schema = required ? _validationSchema.baseString.required(_validationSchema.genericRequiredLabel) : _validationSchema.baseString;
  return _objectSpread({
    type: supportedTypes.RADIO,
    name: name,
    label: label,
    options: _constants.booleanCheckOptions,
    formatDisplay: _helpers.formatDisplayForOptions,
    schema: schema,
    required: required
  }, attrs);
}
/**
 * Return two fields needed to make this field type work properly.
 * - Field 1: the visual checkbox for UI purposes only (ack the info)
 * - Field 2: the actual input with the value needed for the API (hidden).
 * @param {Object} parameters
 * @param {String} parameters.name - The field name
 * @param {String} parameters.label - The field label
 * @param {String} parameters.description - The field description
 * @param {String} parameters.defaultValue - The default value
 * @return {Object}
 */


function composeFieldAck(_ref2) {
  var name = _ref2.name,
      label = _ref2.label,
      description = _ref2.description,
      _ref2$defaultValue = _ref2.defaultValue,
      defaultValue = _ref2$defaultValue === void 0 ? 'acknowledged' : _ref2$defaultValue,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, ["name", "label", "description", "defaultValue"]);
  return _objectSpread({
    type: supportedTypes.ACK_CHECK,
    name: name,
    label: label,
    description: description,
    defaultValue: defaultValue,
    schema: _validationSchema.validateAck,
    required: true
  }, rest);
}
/**
 * Return base attributes needed for a date field.
 */


function composeFieldDate(_ref3) {
  var name = _ref3.name,
      label = _ref3.label,
      _ref3$required = _ref3.required,
      required = _ref3$required === void 0 ? true : _ref3$required,
      attrs = (0, _objectWithoutProperties2["default"])(_ref3, ["name", "label", "required"]);
  var schema = required ? _validationSchema.dateSchema.required(_validationSchema.genericRequiredLabel) : _validationSchema.dateSchema;
  return _objectSpread({
    type: supportedTypes.DATE,
    name: name,
    label: label,
    placeholder: 'YYYY-MM-DD',
    schema: schema,
    required: required
  }, attrs);
}
/**
 * Return base attributes needed for a money field.
 */


function composeFieldMoney(_ref4) {
  var name = _ref4.name,
      label = _ref4.label,
      _ref4$currency = _ref4.currency,
      currency = _ref4$currency === void 0 ? 'EUR' : _ref4$currency,
      _ref4$required = _ref4.required,
      required = _ref4$required === void 0 ? true : _ref4$required,
      attrs = (0, _objectWithoutProperties2["default"])(_ref4, ["name", "label", "currency", "required"]);
  var schema = required ? _validationSchema.currencyAmountSchema.required(_validationSchema.genericRequiredLabel) : _validationSchema.currencyAmountSchema;
  return _objectSpread({
    type: supportedTypes.MONEY,
    name: name,
    label: label,
    currency: currency,
    value: function value(_value2) {
      return (_value2 === null || _value2 === void 0 ? void 0 : _value2.toString()) || '';
    },
    parseValueFromAPI: _currency.convertFromCents,
    parseValueToAPI: _currency.convertToCents,
    formatDisplay: function formatDisplay(value) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Do not turn into arrow function to preserve "this"
      var money = opts.isNotInCents ? (0, _currency.convertToCents)(value) : value;
      return (0, _currency.friendlyMoney)(money, {
        code: this.currency
      });
    },
    schema: schema,
    required: required
  }, attrs);
}
/**
 * Return base attributes needed for a country field.
 * @param {Object} attrs.countries - List of countries
 * @param {Function} attrs.onChange - callback fn with params object from react-select + formik { selectedOption, meta, previousValue, setValue, formValues }
 */


function composeFieldCountries(_ref5) {
  var countries = _ref5.countries,
      name = _ref5.name,
      label = _ref5.label,
      _ref5$required = _ref5.required,
      required = _ref5$required === void 0 ? true : _ref5$required,
      attrs = (0, _objectWithoutProperties2["default"])(_ref5, ["countries", "name", "label", "required"]);
  var schema = required ? _validationSchema.baseString.required(_validationSchema.genericRequiredLabel) : _validationSchema.baseString;
  return _objectSpread({
    type: supportedTypes.COUNTRIES,
    name: name,
    label: label,
    placeholder: 'Select country',
    countries: countries,
    schema: schema,
    required: required
  }, attrs);
}

function composeFieldCountriesMulti(_ref6) {
  var countries = _ref6.countries,
      name = _ref6.name,
      label = _ref6.label,
      _ref6$required = _ref6.required,
      required = _ref6$required === void 0 ? true : _ref6$required,
      attrs = (0, _objectWithoutProperties2["default"])(_ref6, ["countries", "name", "label", "required"]);
  return composeFieldCountries(_objectSpread({
    name: name,
    label: label,
    displayLabel: true,
    isMulti: true,
    countries: countries,
    required: required,
    formatDisplay: function formatDisplay(value) {
      if (!value) return value;
      if (typeof value === 'string') return value;

      if (Array.isArray(value) && value.every(function (val) {
        return !!val && (val === null || val === void 0 ? void 0 : val.name);
      })) {
        return value.map(function (val) {
          return val.name;
        }).join(', ');
      }

      return null;
    },
    transformValue: function transformValue(options) {
      if (Array.isArray(options)) {
        return options.map(function (option) {
          return option.name;
        }).join(',');
      } // In case user removes selected options


      return (options === null || options === void 0 ? void 0 : options.name) || '';
    },
    parseValueFromAPI: function parseValueFromAPI(value) {
      if (typeof value === 'string') {
        var countryNames = value.split(',');
        var countryValues = countryNames.map( // Return {name: countryName } as fallback to support legacy data,
        // (when the fields were open text fields without country select)
        function (countryName) {
          return countries.find(function (country) {
            return country.name === countryName;
          }) || {
            name: countryName
          };
        });
        return countryValues;
      }

      return value || '';
    },
    parseValueToAPI: function parseValueToAPI(valueList) {
      if (Array.isArray(valueList)) {
        return valueList.map(function (option) {
          return option.name;
        }).join(',');
      }

      return valueList;
    }
  }, attrs));
}
/**
 * Return base attributes needed for a number field.
 * @param {Object} attrs
 * @return {Object}
 */


function composeFieldNumber(_ref7) {
  var name = _ref7.name,
      label = _ref7.label,
      _ref7$required = _ref7.required,
      required = _ref7$required === void 0 ? true : _ref7$required,
      attrs = (0, _objectWithoutProperties2["default"])(_ref7, ["name", "label", "required"]);
  var schema = required ? _validationSchema.validateIsNumber.required(_validationSchema.genericRequiredLabel) : _validationSchema.validateIsNumberOptional;
  return _objectSpread({
    type: supportedTypes.NUMBER,
    name: name,
    label: label,
    required: required,
    schema: schema,
    value: function value(_value3) {
      return ['string', 'number'].includes(typeof _value3) ? _value3.toString() : '';
    },
    parseValueToAPI: function parseValueToAPI(value) {
      return ['string', 'number'].includes(typeof value) ? parseInt(value, 10) : null;
    }
  }, attrs);
}
/**
 * Return base attributes needed for a text field.
 * @param {Object} attrs
 * @return {Object}
 */


function composeFieldText(_ref8) {
  var name = _ref8.name,
      label = _ref8.label,
      _ref8$required = _ref8.required,
      required = _ref8$required === void 0 ? true : _ref8$required,
      attrs = (0, _objectWithoutProperties2["default"])(_ref8, ["name", "label", "required"]);
  var schema = required ? _validationSchema.baseString.required(_validationSchema.genericRequiredLabel) : _validationSchema.baseString;
  return _objectSpread({
    type: supportedTypes.TEXT,
    name: name,
    label: label,
    required: required,
    schema: schema
  }, attrs);
}
/**
 * Return base attributes needed for a textarea field.
 * @param {Object} attrs
 * @return {Object}
 */


function composeFieldTextarea(_ref9) {
  var name = _ref9.name,
      label = _ref9.label,
      _ref9$required = _ref9.required,
      required = _ref9$required === void 0 ? true : _ref9$required,
      attrs = (0, _objectWithoutProperties2["default"])(_ref9, ["name", "label", "required"]);
  var schema = required ? _validationSchema.baseString.required(_validationSchema.genericRequiredLabel) : _validationSchema.baseString;
  return _objectSpread({
    type: supportedTypes.TEXTAREA,
    name: name,
    label: label,
    required: required,
    schema: schema
  }, attrs);
}
/**
 * Return base attributes needed for an extra field.
 * @param {Object} attrs
 * @return {Object}
 */


function composeFieldExtra(_ref10) {
  var Component = _ref10.Component,
      attrs = (0, _objectWithoutProperties2["default"])(_ref10, ["Component"]);
  return _objectSpread({
    type: supportedTypes.EXTRA,
    name: '',
    Component: Component
  }, attrs);
}
/**
 * Return base attributes needed for a select field.
 * @param {Object} attrs
 * @return {Object}
 */


function composeFieldSelect(_ref11) {
  var name = _ref11.name,
      label = _ref11.label,
      _ref11$required = _ref11.required,
      required = _ref11$required === void 0 ? true : _ref11$required,
      options = _ref11.options,
      _ref11$transformValue = _ref11.transformValue,
      transformValue = _ref11$transformValue === void 0 ? function (option) {
    return option.value;
  } : _ref11$transformValue,
      _ref11$formatDisplay = _ref11.formatDisplay,
      formatDisplay = _ref11$formatDisplay === void 0 ? _helpers.formatDisplayForOptions : _ref11$formatDisplay,
      _ref11$displayLabel = _ref11.displayLabel,
      displayLabel = _ref11$displayLabel === void 0 ? true : _ref11$displayLabel,
      attrs = (0, _objectWithoutProperties2["default"])(_ref11, ["name", "label", "required", "options", "transformValue", "formatDisplay", "displayLabel"]);
  var schema = required ? _validationSchema.baseString.required(_validationSchema.genericRequiredLabel) : _validationSchema.baseString;
  return _objectSpread(_objectSpread({
    type: supportedTypes.SELECT,
    name: name,
    label: label,
    options: options,
    transformValue: transformValue,
    formatDisplay: formatDisplay,
    required: required,
    schema: schema
  }, label ? {
    displayLabel: displayLabel
  } : {}), attrs);
}